import {useCanManageBilling} from './useOrganizationPermissions'
import {useCanManageProject} from './useProjectPermissions'

export function useCanOpenCheckout() {
  const canManageProject = useCanManageProject()
  const canManageBilling = useCanManageBilling()
  return canManageProject || canManageBilling
}
